/**
 * Slide-open/close animation for theme accordions (<details> inside .accordion).
 * Progressive enhancement: without JS, accordions toggle natively (instant).
 * Respects prefers-reduced-motion.
 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DURATION = 260;
  const EASING = 'ease';

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.accordion details > summary');
    if (!summary || reducedMotion.matches) return;

    const details = summary.parentElement;
    const content = summary.nextElementSibling;
    if (!content || details.dataset.animating === 'true') {
      if (details.dataset.animating === 'true') event.preventDefault();
      return;
    }

    event.preventDefault();
    details.dataset.animating = 'true';

    const finish = (open) => {
      details.open = open;
      details.dataset.animating = 'false';
      content.style.removeProperty('height');
      content.style.removeProperty('overflow');
    };

    if (details.open) {
      // Collapse
      const start = content.offsetHeight;
      content.style.overflow = 'hidden';
      const anim = content.animate(
        [{ height: `${start}px`, opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = () => finish(false);
      anim.oncancel = () => finish(false);
    } else {
      // Expand
      details.open = true;
      const end = content.offsetHeight;
      content.style.overflow = 'hidden';
      const anim = content.animate(
        [{ height: '0px', opacity: 0 }, { height: `${end}px`, opacity: 1 }],
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = () => finish(true);
      anim.oncancel = () => finish(true);
    }
  });
})();
